/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareIcon24Solid = forwardRef('CheckSquareIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 2A4.5 4.5 0 0 0 2 6.5v11A4.5 4.5 0 0 0 6.5 22h11a4.5 4.5 0 0 0 4.5-4.5v-11A4.5 4.5 0 0 0 17.5 2h-11Zm11.921 7.387a1.25 1.25 0 1 0-1.767-1.767l-6.142 6.141a.25.25 0 0 1-.353 0l-2.432-2.432a1.25 1.25 0 0 0-1.768 1.768l2.432 2.432a2.75 2.75 0 0 0 3.89 0l6.14-6.142Z" })));
});
